var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "imageContainer", staticClass: "lc-project-images" },
    [
      _vm.images && _vm.images.length > 1 && _vm.showCarousel
        ? _c(
            "div",
            {
              ref: "projectCarousel",
              class: [
                "lc-project-carousel",
                { "lc-project-show-carousel": _vm.showCarousel },
              ],
            },
            _vm._l(_vm.images, function (image, index) {
              return _c("div", { key: index, staticClass: "slider-img-cont" }, [
                _c("a", { attrs: { href: _vm.lifeDetailsUrl } }, [
                  _c("img", {
                    attrs: { src: image.thumbnailImage },
                    on: { load: _vm.loaded },
                  }),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.showCarousel
        ? _c(
            "div",
            {
              staticClass:
                "lc-project-slider-arrow lc-project-slider-arrow-right",
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_arrow_right"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.showCarousel
        ? _c(
            "div",
            {
              staticClass:
                "lc-project-slider-arrow lc-project-slider-arrow-left",
              on: {
                click: function ($event) {
                  return _vm.prev()
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_arrow_left"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.images && _vm.images.length > 0
        ? _c(
            "div",
            {
              class: [
                "lc-project-main-image",
                { "lc-project-hide-main": _vm.showCarousel },
              ],
            },
            [
              _c("a", { attrs: { href: _vm.lifeDetailsUrl } }, [
                _c("img", {
                  attrs: { src: _vm.images[0].thumbnailImage },
                  on: { load: _vm.loaded },
                }),
              ]),
              _vm.images.length > 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "lc-project-slider-arrow lc-project-slider-arrow-right",
                      on: {
                        click: function ($event) {
                          _vm.showCarousel = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("keyboard_arrow_right"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }